var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('i',{staticClass:"sidebar_nav_icon fa fa-fw",class:_vm.iconClass,attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
			el: _vm.targetId,
			duration: _vm.scrollToSpeed,
			easing: 'ease-in-out'
	}),expression:"{\n\t\t\tel: targetId,\n\t\t\tduration: scrollToSpeed,\n\t\t\teasing: 'ease-in-out'\n\t}"}],staticClass:"nostyle",attrs:{"href":"#"}},[_c('span',{staticClass:"sidebar_item_name"},[_vm._v(_vm._s(_vm.name))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d15a0f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/sidebarItem.vue
// module id = 2o2m
// module chunks = 0